module.exports = __webpack_public_path__ + "img/cart-img-2.jpg";